import React, { useContext } from "react";

import {
  ModalContainer,
  ModalContainerBodyContainer,
  ModalContainerBody,
} from "./styled";

import { CoreContext } from "context/CoreContext";
import CardAddSchedule from "components/Cards/AddSchedule";

export default function ModalSchedule() {
  const { modal, setModal } = useContext(CoreContext);

  
  const close = () => {
    setModal(null);
  };

  return (
    <>
      <ModalContainer>
        <ModalContainerBodyContainer>
          <ModalContainerBody>
            <CardAddSchedule
              closeable={close}
              campaign={modal?.item}
              typeModal={modal?.item?.type}
              reload={modal?.reload}
            />
          </ModalContainerBody>
        </ModalContainerBodyContainer>
      </ModalContainer>
    </>
  );
}
